define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaStockTypeDomain = void 0;
    class WaStockTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: WaStockTypeDomain.LargeStock, value: "Large Stock" },
                    { key: WaStockTypeDomain.SmallStock, value: "Small Stock" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[WaStockTypeDomain.LargeStock] = 0;
                this.KeyIndex[WaStockTypeDomain.SmallStock] = 1;
                this.ValueIndex = {};
                this.ValueIndex["Large Stock"] = 0;
                this.ValueIndex["Small Stock"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.WaStockTypeDomain = WaStockTypeDomain;
    Object.defineProperty(WaStockTypeDomain, "LargeStock", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(WaStockTypeDomain, "SmallStock", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(WaStockTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
